<template>
    <div>
        <LoadingOverlay :loading="loading" />
        <div class="topThreeRewards-box">
            <div class="rewardsBoxes">
                <div class="rewardsBox">
                    <div class="rewardsBox-In"
                        @click="redirectProfile(CharmThisweekData[1].id, CharmThisweekData[1].profile_id, CharmThisweekData[1].charm_level)">
                        <div class="rewardsProfile-imageBox">
                            <img :src='ProfileFrame2' class="profile-imgFrame" alt="pf-frame" />
                            <div class="profile-imageBox" v-if="CharmThisweekData.length > 1">
                                <img class="overlapImg" :src='CharmThisweekData[1].profile_images[0].image_name'
                                    alt="User Image" />
                            </div>
                            <div class="rewards-level" v-if="CharmThisweekData.length > 1">
                                <img :src="getLevelImage(CharmThisweekData[1].charm_level)" class="lavelImage"
                                    alt="level icon" />
                                <span class="lavel-value">{{ CharmThisweekData[1].charm_level }}</span>
                            </div>
                        </div>
                        <div class="userName-box">
                            <div class="userName" v-if="CharmThisweekData.length > 1">
                                {{ CharmThisweekData[1].name }}
                            </div>
                            <div class="beansBox">
                                <img :src='beansIcon' class="beansIcon" alt="" />
                                <span class="beansValue" v-if="CharmThisweekData.length > 1">{{
                            CharmThisweekData[1].weekly_earning_beans
                        }}</span>
                            </div>
                            <div class="userRewardsBox mt-0 rewardBlast-orangeText" v-if="CharmThisweekData.length > 1">
                                <div v-if="CharmThisweekData[1].reward_blast > 0">
                                    <span>Blast Reward</span>{{ CharmThisweekData[1].reward_blast }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="rewardsBox center-rewardsBox">
                    <div class="rewardsBox-In"
                        @click="redirectProfile(CharmThisweekData[0].id, CharmThisweekData[0].profile_id, CharmThisweekData[0].charm_level)">
                        <div class="rewardsProfile-imageBox">
                            <img :src='ProfileFrame1' class="profile-imgFrame" alt="pf-frame" />
                            <div class="profile-imageBox" v-if="CharmThisweekData.length > 0">
                                <img class="overlapImg" :src='CharmThisweekData[0].profile_images[0].image_name'
                                    alt="User Image" />
                            </div>
                            <div class="rewards-level" v-if="CharmThisweekData.length > 0">
                                <img :src="getLevelImage(CharmThisweekData[0].charm_level)" class="lavelImage"
                                    alt="level icon" />
                                <span class="lavel-value">{{ CharmThisweekData[0].charm_level }}</span>
                            </div>
                        </div>
                        <div class="userName-box">
                            <div class="userName" v-if="CharmThisweekData.length > 0">{{ CharmThisweekData[0].name
                                }}
                            </div>
                            <div class="beansBox">
                                <img :src='beansIcon' class="beansIcon" alt="" />
                                <span class="beansValue" v-if="CharmThisweekData.length > 0">{{
                            CharmThisweekData[0].weekly_earning_beans
                        }}</span>
                            </div>
                            <div class="userRewardsBox mt-0 rewardBlast-orangeText" v-if="CharmThisweekData.length > 1">
                                <div v-if="CharmThisweekData[0].reward_blast > 0">
                                    <span>Blast Reward</span>{{ CharmThisweekData[0].reward_blast }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="rewardsBox">
                    <div class="rewardsBox-In"
                        @click="redirectProfile(CharmThisweekData[2].id, CharmThisweekData[2].profile_id, CharmThisweekData[2].charm_level)">
                        <div class="rewardsProfile-imageBox">
                            <img :src='ProfileFrame3' class="profile-imgFrame" alt="pf-frame" />
                            <div class="profile-imageBox" v-if="CharmThisweekData.length > 2">
                                <img class="overlapImg" :src='CharmThisweekData[2].profile_images[0].image_name'
                                    alt="User Image" />
                            </div>
                            <div class="rewards-level" v-if="CharmThisweekData.length > 2">
                                <img :src="getLevelImage(CharmThisweekData[2].charm_level)" class="lavelImage"
                                    alt="level icon" />
                                <span class="lavel-value">{{ CharmThisweekData[2].charm_level }}</span>
                            </div>
                        </div>
                        <div class="userName-box">
                            <div class="userName" v-if="CharmThisweekData.length > 2">{{ CharmThisweekData[2].name
                                }}
                            </div>
                            <div class="beansBox">
                                <img :src='beansIcon' class="beansIcon" alt="" />
                                <span class="beansValue" v-if="CharmThisweekData.length > 2">{{
                            CharmThisweekData[2].weekly_earning_beans
                        }}</span>
                            </div>
                            <div class="userRewardsBox mt-0 rewardBlast-orangeText" v-if="CharmThisweekData.length > 1">
                                <div v-if="CharmThisweekData[2].reward_blast > 0">
                                    <span>Blast Reward</span>{{ CharmThisweekData[2].reward_blast }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="podiumImageBox">
                <img class="podiumImage" :src='podiumImage' alt="Podium Image" />
            </div>
        </div>
        <div class="fixHeight ringlive-datalistWrap">
            <div class="listBoxes" v-for="(reward, index) in CharmThisweekData.slice(3) " :key="reward.id"
                @click="redirectProfile(reward.id, reward.profile_id, reward.charm_level)">
                <div class="leftBxb">
                    <div class="s-no">{{ index + 4 }}</div>
                    <div class="listIconBox">
                        <div class="profPic">
                            <img :src='(reward.profile_images.length > 0) ? reward.profile_images[0].image_name : defaultUserImage'
                                alt="User Image" />
                        </div>
                    </div>
                    <div class="name-lavel-box">
                        <div class="userName">{{ reward.name }}</div>
                        <div class="lavel-box">
                            <img :src="getLevelImage(reward.charm_level)" class="lavelImage" alt="level icon" />
                            <span class="lavel-value">{{ reward.charm_level }}</span>
                        </div>
                    </div>
                </div>
                <div class="rightBox">
                    <div class="rightBox-in">
                        <div class="beansBox">
                            <img :src='beansIcon' class="beansIcon" alt="beans icons" />
                            {{ reward.weekly_earning_beans }}
                        </div>
                        <div class="userRewardsBox rewardBlast-orangeText" v-if="reward.reward_blast > 0"><span>Blast Reward</span>{{ reward.reward_blast }}</div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="personalDetails" class="listBoxes myselfBox"
            @click="redirectProfile(personalDetails.id, personalDetails.profile_id, personalDetails.charm_level)">
            <div class="leftBxb">
                <div class="s-no">-</div>
                <div class="listIconBox">
                    <div class="profPic">
                        <!-- <img :src='(personalDetails.profile_images.length > 0) ? personalDetails.profile_images[0].image_name : defaultUserImage'
                            alt="User Image" /> -->
                        <img :src="personalDetails.profile_images.length > 0 ? personalDetails.profile_images[0].image_name : defaultUserImage"
                        alt="User Image" @error="setDefaultImage" />
                    </div>
                </div>
                <div class="name-lavel-box">
                    <div class="userName">{{ personalDetails.name }}</div>
                    <div class="lavel-box">
                        <img :src="getLevelImage(personalDetails.charm_level)" class="lavelImage" alt="level icon" />
                        <span class="lavel-value">{{ personalDetails.charm_level }}</span>
                    </div>
                </div>
            </div>
            <div class="rightBox">
                <div class="rightBox-in"><img :src='beansIcon' class="beansIcon" alt="beans icons" />{{
                    personalDetails.weekly_earning_beans }}</div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios'
import ProfileFrame1 from '../../assets/images/rank1-frameImage.png'
import ProfileFrame2 from '../../assets/images/rank2-frameImage.png'
import ProfileFrame3 from '../../assets/images/rank3-frameImage.png'
import beansIcon from '../../assets/images/beansIcon.png'
import podiumImage from '../../assets/images/podium-background.webp'
import defaultUserImage from '../../assets/images/default_profile.webp';
import LoadingOverlay from '../LoadingOverlay.vue'
export default {
    name: 'ThisWeekTabCont',
    components: {
        LoadingOverlay
    },
    data() {
        return {
            CharmThisweekData: [],
            personalDetails: null,
            ProfileFrame1: ProfileFrame1,
            ProfileFrame2: ProfileFrame2,
            ProfileFrame3: ProfileFrame3,
            beansIcon: beansIcon,
            podiumImage: podiumImage,
            defaultUserImage: defaultUserImage,
            loading: false, // State to track loading status
        }
    },
    watch: {
        '$route.params.profile_id': 'fetchCharmThisweekData'
    },
    mounted() {
        this.fetchCharmThisweekData();
    },
    methods: {
        fetchCharmThisweekData() {
            this.loading = true; // Set loading to true before making the request
            const tokenParam = this.$route.params.token;
            const token = tokenParam.split('=')[0];
            const apiUrl = `api/top-charm-weekly?type=this_week`;
            axios.get(apiUrl, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            })
                .then(response => {
                    this.CharmThisweekData = response.data.result.data;
                    this.personalDetails = response.data.result.personal_details;
                    this.checkAllImagesExist();
                })
                .catch(error => {
                    console.error("Error Featching This Week Data", error)
                })
                .finally(() => {
                    this.loading = false;
                })
        },
        getLevelImage(charm_level) {
            switch (true) {
                case charm_level === 0:
                    return require('@/assets/images/charm-lavel-0.png');
                case charm_level === 1:
                    return require('@/assets/images/charm-lavel-1.png');
                case charm_level === 2:
                    return require('@/assets/images/charm-lavel-2.png');
                case charm_level === 3:
                    return require('@/assets/images/charm-lavel-3.png');
                case charm_level === 4:
                    return require('@/assets/images/charm-lavel-4.png');
                case charm_level === 5:
                    return require('@/assets/images/charm-lavel-5.png');
                case charm_level >= 6 && charm_level <= 10:
                    return require('@/assets/images/charm-lavel-6-10.png');
                case charm_level >= 11 && charm_level <= 15:
                    return require('@/assets/images/charm-lavel-11-15.png');
                case charm_level >= 16 && charm_level <= 40:
                    return require('@/assets/images/charm-lavel-16-20.png');
                default:
                    return require('@/assets/images/charm-lavel-0.png');
            }
        },
        checkAllImagesExist() {
            this.CharmThisweekData.forEach(reward => {
                if (reward.profile_images.length > 0) {
                    const imageUrl = reward.profile_images[0].image_name;
                    this.checkImageExists(imageUrl)
                        .then(exists => {
                            if (!exists) {
                                reward.profile_images[0].image_name = this.defaultUserImage;
                            }
                        });
                } else {
                    reward.profile_images = [{ image_name: this.defaultUserImage }];
                }

            });
        },
        checkImageExists(imageUrl) {
            return new Promise((resolve) => {
                var img = new Image();
                img.onload = function () {
                    resolve(true);
                };
                img.onerror = function () {
                    resolve(false);
                };
                img.src = imageUrl;
            });
        },

        setDefaultImage(event) {
            event.target.src = this.defaultUserImage;
        },

        redirectProfile(id, profile_id, level) {
            if (window.navigator.userAgent.indexOf("Android") > -1) {
                const baseURL = 'female-weekly-rewards';
                const params = {
                    id: id,
                    profile_id: profile_id,
                    level: level
                };
                const queryString = Object.keys(params)
                    .map(key => `${key}=${params[key]}`)
                    .join('&');
                const url = `${baseURL}?${queryString}`;
                //   window.location.href = url;
                Android.redirectProfile(url);
            }
        }
    },
}
</script>